var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-pagination',{staticClass:"mt-3",attrs:{"id":"page","size":"sm","align":"fill","total-rows":_vm.pagination.totalRows,"per-page":_vm.pagination.perPage},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }